import { render } from "./ProductComparisonTableColumnHeader.vue?vue&type=template&id=a3433006"
import script from "./ProductComparisonTableColumnHeader.vue?vue&type=script&lang=js"
export * from "./ProductComparisonTableColumnHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__